module.exports = __webpack_public_path__ + "static/storage-base-4-52ca32f9f5c54deb0baf6d0576e8fec7.webp";